import { render, staticRenderFns } from "./StockEditSizeRows.vue?vue&type=template&id=5156e2a1&scoped=true"
import script from "./StockEditSizeRows.vue?vue&type=script&lang=ts"
export * from "./StockEditSizeRows.vue?vue&type=script&lang=ts"
import style0 from "./StockEditSizeRows.vue?vue&type=style&index=0&id=5156e2a1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5156e2a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5156e2a1')) {
      api.createRecord('5156e2a1', component.options)
    } else {
      api.reload('5156e2a1', component.options)
    }
    module.hot.accept("./StockEditSizeRows.vue?vue&type=template&id=5156e2a1&scoped=true", function () {
      api.rerender('5156e2a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stock/StockEditSizeRows.vue"
export default component.exports